// Pipeline Section (Statement of Work)
export const FETCH_SHIPMENTS_DETAILS = '@@fetch-shipments-details';
export const FETCH_SHIPMENTS_DETAILS_SUCCESS = '@@fetch-shipments-details-success';
export const FETCH_SHIPMENTS_DETAILS_FAILURE = '@@fetch-shipments-details-failure';
